export default __webpack_public_path__ + "static/media/Sandals of the Crawling Chaos.7b809751.jpg";